import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../../services/authService";
import "./Login.css";
import Alert from "../HtmlElements/Alert";
import { JS_CSS_IMG_VERSION } from "../../config/apiConfig";
// import 'font-awesome/4.5.0/css/font-awesome.min.css';
// import 'fonts.googleapis.com.css.css';
<link rel="stylesheet" href="font-awesome/4.5.0/css/font-awesome.min.css" />;
<link rel="stylesheet" href="fonts.googleapis.com.css.css" />;

const Otp = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let my_data = await login(email, password);

      localStorage.setItem("access_token", my_data.access_token);
      localStorage.setItem("refresh_token", my_data.refresh_token);

      navigate("/users");
    } catch (err) {
      setError(err.message || "Login failed");
    }
  };

  return (
    <div>
      <div className="main-container">
        <div className="main-content">
          <div className="row">
            <div className="col-sm-12">
              <div className="login-container">
                <div className="center">
                  <h4 className="blue" id="id-company-text">
                    <img src={`/img/mnm_logo_inner.png?version=${JS_CSS_IMG_VERSION}`} width="200" />
                  </h4>
                </div>
                <div className="space-4"></div>

                <h2 className="login_head header blue">
                  <i className="ace-icon fa fa-envelope-open blue mr-1"></i>
                  Please enter the OTP received
                </h2>
                <div className="space-6"></div>

                {error && <Alert type="danger" message={error} />}
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label custom_label">
                      Please enter the OTP to verify the account
                    </label>
                    <span className="block input-icon input-icon-right">
                      <input
                        type="password"
                        className="form-control custom_form_control"
                        id="email"
                        placeholder="Please enter OTP received "
                        autoComplete="off"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                      <i className="ace-icon fa fa-eye"></i>
                    </span>
                  </div>

                  <div className="space-6"></div>
                  <button
                    type="submit"
                    className="btn btn-primary custom_login_btn width-35 pull-right"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Otp;
